import {Component, inject} from "@angular/core";
import {RouterLink} from "@angular/router";
import {WEB_APP_CONFIG} from "../../../common/app-config";
import {Header} from "../../layout/header/header";
import {LargeLogoShear} from "../../layout/large-logo-shear/large-logo-shear";

@Component({
  selector: "app-privacy",
  templateUrl: "./privacy.html",
  imports: [
    Header,
    RouterLink,
    LargeLogoShear,
  ],
})
export default class Privacy {
  protected readonly isUsingAppleMaps = inject(WEB_APP_CONFIG).appleMapsEmbeddingSettings !== undefined;
}
